import dayjs from "dayjs"
import { ProjectView } from "~/backendApis/viewModel"

// TODO: projectSearch.tsで定義されているdecorateProjectViewをここに移行
export const projectDecorator = (view: ProjectView) => ({
  get isNew(): boolean {
    // 1週間以内に公開したプロジェクトを新着(isNew)とする
    const oneWeekBeforeNow: dayjs.Dayjs = dayjs().subtract(1, "week")
    const projectDate = dayjs(new Date(view.publishedDateTime || ""))

    return projectDate >= oneWeekBeforeNow
  },
})
